const risk = {
  id: "risk",
  title: "Risk Management & Contingency Planning",
  questions: [
    {
      question: "How do you prepare for unexpected disruptions during an event?",
      answer: "We create a structured contingency plan covering logistics, vendors, weather, and medical support before execution begins."
    },
    {
      question: "What happens if there are last-minute flight delays or cancellations?",
      answer: "Our team monitors flight schedules in real time and activates alternate transport or rescheduling protocols immediately."
    },
    {
      question: "How do you manage weather-related risks for outdoor events?",
      answer: "We pre-identify indoor backup venues, alternate setups, and flexible scheduling options in advance."
    },
    {
      question: "How do you handle vendor failure or technical breakdowns?",
      answer: "We maintain standby vendors and backup technical equipment to ensure uninterrupted execution."
    },
    {
      question: "Is there a crisis response team available during the event?",
      answer: "Yes. A dedicated control desk and escalation hierarchy remain active for immediate resolution."
    },
    {
      question: "How do you ensure guest safety during travel movements?",
      answer: "We work with verified transport partners, licensed drivers, and route planning systems to minimize risk."
    },
    {
      question: "What measures are taken for crowd control in large gatherings?",
      answer: "We deploy structured entry systems, access badges, security coordination, and movement flow planning."
    },
    {
      question: "Are insurance or compliance aspects covered?",
      answer: "We assist with travel insurance coordination and ensure venue compliance requirements are fulfilled."
    },
    {
      question: "How do you prevent operational miscommunication on-ground?",
      answer: "We operate through pre-event briefings, detailed run-of-show documents, and real-time coordination channels."
    }
  ]
};

export default risk;
